// extracted by mini-css-extract-plugin
export default {"storyList":"c-a_ac","storyList_grid":"c-a_ae"};